import remarkGfm from 'remark-gfm';
import remarkParse from 'remark-parse';
import { unified } from 'unified';
import { EXIT, visit } from 'unist-util-visit';

export const containsGfmTable = (markdown: string) => {
  if (!markdown) return false;

  const tree = unified().use(remarkParse).use(remarkGfm).parse(markdown);

  let hasTable = false;
  visit(tree, 'table', () => {
    hasTable = true;
    return EXIT;
  });

  return hasTable;
};
